/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
// Extends from
import Route from '@ember/routing/route';
// Ember imports
import { service } from '@ember/service';
import { alias } from '@ember/object/computed';
import { action } from '@ember/object';
import { hash } from '@linc-technologies/linced-common/utils/promise';
// External imports
import SnapshotType from '@linc-technologies/linced-common/enums/snapshot-type';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

export default class ReportSnapshotsRoute extends Route {
  // Services
  @service
  dates;

  @service
  session;

  @service
  store;

  // Attrs
  @alias('session.activeSchool')
  schoolId;

  @alias('session.school.jurisdiction')
  jurisdiction;

  // Hooks
  model() {
    let data = {
      school: this.store.findRecord('school', this.schoolId),
      customSnapshotSets: this.store.query('snapshots/snapshot-set', {
        schoolId: this.schoolId,
        resourceType: 2,
        resourceId: this.schoolId,
        snapshotType: SnapshotType.ON_DEMAND,
      }),
      timeframes: this.store.query('timeframe', {
        schoolId: this.schoolId,
        year: this.dates.currentAcademicYear,
      }),
    };
    // UK and default = termly
    // NZ MoE and NSW = bi-annual (semester)
    let autoType = SnapshotType.TERMLY; // default
    switch (this.jurisdiction) {
      case Jurisdiction.NZ_MOE:
      case Jurisdiction.AU_NSW:
        autoType = SnapshotType.BIANNUAL;
    }
    data.autoSnapshotSets = this.store.query('snapshots/snapshot-set', {
      schoolId: this.schoolId,
      resourceType: 2,
      resourceId: this.schoolId,
      snapshotType: autoType,
    });

    return hash(data);
  }

  setupController(controller, model) {
    super.setupController(...arguments);
    controller.setProperties({
      displayedCustomSnapshotSets: model.customSnapshotSets,
      displayedAutoSnapshotSets: model.autoSnapshotSets,
    });
  }

  // `renderTemplate`/`render` were removed in Ember 4.0. `templateName` is
  // the supported way to choose a template; a getter keeps it dynamic.
  get templateName() {
    return this.jurisdiction === Jurisdiction.AU_NSW
      ? 'report-snapshots/report-snapshots-nsw'
      : 'report-snapshots/report-snapshots-default';
  }

  @action
  refreshModel() {
    this.refresh();
  }
}
